// extracted by mini-css-extract-plugin
export default {"row-dragging":"draggableTable_row-dragging__ohARB","record-label":"draggableTable_record-label__LyCqT","drag-visible":"draggableTable_drag-visible__8QSz8"};